import { ArrowPathIcon } from "@heroicons/react/24/outline"
import { Route, Routes, } from "react-router-dom"
import { RouteElement } from "../../../interfaces/_common"
import { SubMenuTabs } from "../common"
import RouteKeys from "constants/route-keys"
import CachePurgeTool from "./CachePurgeTool"

const _routes: RouteElement[] = [
    {
        // use empty string so the list renders at /purge-tool
        route: '',
        title: 'Cache Purge Tool',
        key: RouteKeys.CACHE_PURGE,
        component: CachePurgeTool,
        icon: ArrowPathIcon,
        display: true
    }
]
const CachePurge = () => {
    return (
        <div>
            <SubMenuTabs _routes={_routes} />
            <div className="p-3">
                <Routes>
                    {
                        _routes.map((route, index) => (
                            <Route key={index} path={`${route.route}${route.hasChild ? '/*' : ''}`} element={<route.component />} />
                        ))
                    }
                </Routes>
            </div>
        </div>
    )
}

export default CachePurge